'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _liveChatLink = require('../../selectors/widgetDataSelectors/liveChatLink');

var _pubsubConnectionFailed = require('../../pubsub/selectors/pubsubConnectionFailed');

var _getCurrentConversation = require('../../selectors/conversationSelectors/getCurrentConversation');

var _getCurrentThreadId = require('../../selectors/conversationSelectors/getCurrentThreadId');

var _chatSelectors = require('../../selectors/chatSelectors');

var _getIsMobile = require('../../selectors/getIsMobile');

var _republishMessage = require('../../actions/PublishActions/republishMessage');

var _VisitorEmailAddressActions = require('../../email-capture/actions/VisitorEmailAddressActions');

var _WidgetActions = require('../../actions/WidgetActions');

var _visitorConsentsToProcess = require('../../gdpr/actions/visitorConsentsToProcess');

var _getResponders = require('../../responders/selectors/getResponders');

var _getAssignedResponderInWidget = require('../../responders/selectors/getAssignedResponderInWidget');

var _getPotentialResponders = require('../../responders/selectors/getPotentialResponders');

var _getSendFromResponders = require('../../responders/selectors/getSendFromResponders');

var _shouldRequireConsentToCommunicate = require('../../selectors/widgetDataSelectors/shouldRequireConsentToCommunicate');

var _requiresExplicitConsentToProcess = require('../../gdpr/selectors/requiresExplicitConsentToProcess');

var _getConsentToCommunicateMessage = require('../../selectors/widgetDataSelectors/getConsentToCommunicateMessage');

var _getCompanyName = require('../../selectors/widgetDataSelectors/getCompanyName');

var _getUserId = require('../../selectors/userSelectors/getUserId');

var _typingResponder = require('../../typing-indicators/selectors/typingResponder');

var _publishTypingMessage = require('../../typing-indicators/actions/publishTypingMessage');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var _fetchThreadHistory = require('../../thread-histories/actions/fetchThreadHistory');

var _publishMessage = require('../../actions/PublishActions/publishMessage');

var _ThreadedChatArea = require('../components/ThreadedChatArea');

var _ThreadedChatArea2 = _interopRequireDefault(_ThreadedChatArea);

var _getChatHeadingConfig = require('../../chat-heading-config/selectors/getChatHeadingConfig');

var _threadSupportsAttachments = require('../../visitor-widget/selectors/threadSupportsAttachments');

var _selectAttachmentFile = require('../../file-uploads/actions/selectAttachmentFile');

var _removeAttachmentFromThread = require('../../file-uploads/actions/removeAttachmentFromThread');

var _listOfFileUploadsForThreadInProps = require('../../file-uploads/selectors/listOfFileUploadsForThreadInProps');

var _resolvedAttachmentsForThreadFromProps = require('../../resolved-attachments/selectors/resolvedAttachmentsForThreadFromProps');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var _getHasVisitorEmail = require('../../selectors/widgetDataSelectors/getHasVisitorEmail');

var _getHasGivenConsentToProcess = require('../../gdpr/selectors/getHasGivenConsentToProcess');

var _getShouldStageInitialMessage = require('../../threads/selectors/getShouldStageInitialMessage');

var _getShouldStageInitialMessage2 = _interopRequireDefault(_getShouldStageInitialMessage);

var _stageInitialMessage = require('../../actions/PublishActions/stageInitialMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRedux.connect)(function (state) {
  var currentChannel = state.currentChannel;


  var currentConversation = (0, _getCurrentConversation.getCurrentConversation)(state);

  return {
    attachments: (0, _resolvedAttachmentsForThreadFromProps.resolvedAttachmentsForThreadFromProps)(state, {
      thread: currentConversation
    }),
    currentChannel: currentChannel,
    currentConversation: currentConversation,
    currentThreadId: (0, _getCurrentThreadId.getCurrentThreadId)(state),
    hasCapturedVisitorEmail: (0, _getHasVisitorEmail.getHasVisitorEmail)(state),
    hasGivenConsentToProcess: (0, _getHasGivenConsentToProcess.getHasGivenConsentToProcess)(state),
    hasUnansweredQuickReplyMessage: (0, _chatSelectors.hasUnansweredQuickReplyMessage)(state, {
      thread: currentConversation
    }),
    liveChatLink: (0, _liveChatLink.liveChatLink)(state),
    mobile: (0, _getIsMobile.getIsMobile)(state),
    networkOffline: (0, _pubsubConnectionFailed.pubsubConnectionFailed)(state),
    requiresConsentToCommunicate: (0, _shouldRequireConsentToCommunicate.shouldRequireConsentToCommunicate)(state),
    chatHeadingConfig: (0, _getChatHeadingConfig.getChatHeadingConfig)(state),
    consentToCommunicateMessage: (0, _getConsentToCommunicateMessage.getConsentToCommunicateMessage)(state),
    companyName: (0, _getCompanyName.getCompanyName)(state),
    responders: (0, _getResponders.getResponders)(state),
    userId: (0, _getUserId.getUserId)(state),
    assignedResponder: (0, _getAssignedResponderInWidget.getAssignedResponderInWidget)(state),
    potentialResponders: (0, _getPotentialResponders.getPotentialResponders)(state),
    requiresExplicitConsentToProcess: (0, _requiresExplicitConsentToProcess.requiresExplicitConsentToProcess)(state),
    sendFromResponders: (0, _getSendFromResponders.getSendFromResponders)(state),
    shouldStageInitialMessage: (0, _getShouldStageInitialMessage2.default)(state, {
      thread: currentConversation
    }),
    stagedAttachments: (0, _listOfFileUploadsForThreadInProps.listOfFileUploadsForThreadInProps)(state, {
      thread: currentConversation
    }),
    supportsAttachments: (0, _threadSupportsAttachments.threadSupportsAttachments)(state, {
      thread: currentConversation
    }),
    typingResponder: (0, _typingResponder.typingResponder)(state, {
      thread: currentConversation
    }),
    threadHistory: (0, _historyDataForThread.historyDataForThread)(state, {
      thread: currentConversation
    }),
    widgetData: (0, _getWidgetData.getWidgetData)(state)
  };
}, {
  fetchThreadHistory: _fetchThreadHistory.fetchThreadHistory,
  onLinkClick: _WidgetActions.clickedViralLink,
  consentToProcess: _visitorConsentsToProcess.consentToProcess,
  publishMessage: _publishMessage.publishMessage,
  publishTypingMessage: _publishTypingMessage.publishTypingMessage,
  republishMessage: _republishMessage.republishMessage,
  sendVisitorEmailAddress: _VisitorEmailAddressActions.sendVisitorEmailAddress,
  stageInitialMessage: _stageInitialMessage.stageInitialMessage,
  onRemoveAttachment: _removeAttachmentFromThread.removeAttachmentFromThread,
  onSelectAttachmentFile: _selectAttachmentFile.selectAttachmentFile,
  trackInteraction: _trackInteraction.trackInteraction
})(_ThreadedChatArea2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/containers/ThreadedChatAreaContainer.js
// module id = 670
// module chunks = 2 3